import type {HistoryStateDrawing} from '@PosterWhiteboard/poster/poster-history/history-state-drawing';
import type {HistoryStatePoster} from '@PosterWhiteboard/poster/poster-history/history-state-poster';
import type {HistoryStatePosterDiff} from '@PosterWhiteboard/poster/poster-history/history-state-poster-diff';

export type HistoryStates = HistoryStateDrawing | HistoryStatePoster | HistoryStatePosterDiff;

export enum HistoryDirection {
  UNDO = 'undo',
  REDO = 'redo',
}
